<template>
  <div class="payment-success-modal payment-success-modal--card">
    <h2 class="payment-success-modal__title">
      {{ displayTitle }}
    </h2>
    <p class="payment-success-modal__description">
      {{ displayDescription }}
    </p>
    <gl-button
      class="payment-success-modal__continue"
      dark
      title="Continue"
      @click="handleContinue"
    />
  </div>
</template>

<script>
import GlButton from '@/components/gl-button'

export default {
  name: 'PaymentSuccessModal',
  components: { GlButton },
  props: {
    title: { type: String, default: 'Payment Successful!' },
    description: { type: String, default: 'Thank you for your purchase.' },
    isRefreshAction: { type: Boolean, default: false },
    onContinue: { type: Function, default: null },
  },
  computed: {
    displayTitle() {
      return this.isRefreshAction ? 'Quota Refreshed!' : this.title
    },
    displayDescription() {
      return this.isRefreshAction
        ? 'Your report limits have been successfully reset.'
        : this.description
    },
  },
  methods: {
    async handleContinue() {
      if (typeof this.onContinue === 'function') {
        await this.onContinue()
      }
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.payment-success-modal {
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 320px;
}

.payment-success-modal--card {
  background: var(--Background-Primary);
  border-radius: 16px;
}

.payment-success-modal__title {
  margin: 0 0 12px 0;
  font-size: 24px;
  font-weight: 600;
}

.payment-success-modal__description {
  margin: 0 0 24px 0;
  color: var(--Texts-General-Secondary);
  text-align: center;
}

.payment-success-modal__continue {
  height: 34px;
}
</style>
